import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from './DropdownMenu.module.scss';
import Icon from '../Icon/Icon';

export const DropDownItem = props => {
  const { children, disabled, languageFlag, icon, selected, shortcut, onClick, iconPosition, ...others } = props;

  const handleClick = useCallback(
    event => {
      if (onClick && !disabled) {
        onClick(event, this);
      }
    },
    [disabled, onClick]
  );

  return (
    <li data-react-toolbox="menu-item" onClick={handleClick} className={styles.listItem} {...others}>
      {languageFlag && <Icon className={styles.flag} src={languageFlag} />}
      <span>{children}</span>
    </li>
  );
};

DropDownItem.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

DropDownItem.defaultProps = {
  disabled: false,
  selected: false,
};
